<form #formRef="ngForm" [ngClass]="{'preview-active': preview}">
	<bb-page-header [backOnMobile]="['/library/mediaclips']" [icon]="icon" [title]="entity?.title"
		[filename]="entity?.originalfilename" [tabItems]="tabItems" [inModal]="routeOutlet === 'modal'">

		<span class="subtitle">{{ entity?.id }}</span>

		<bb-status *ngIf="mediaclip" [(ngModel)]="mediaclip.status" name="status"></bb-status>

	</bb-page-header>

	<div class="body-column tab-container"
		[ngClass]="{'fullsize': ['streams', 'bb-streams', 'react', 'chapters'].includes(activeTab)}" cdkScrollable>

		<span *ngIf="mediaclip?.uploading" class="message warning ng-binding">
			{{ 'MEDIACLIP_VIDEO_UPLOADING' | translate:translations }}.
		</span>

		<div *ngIf="entity?.mediatype !== 'image' && entity?.mediatype !== 'document' && entity?.mediatype !== 'font'">
			<span *ngIf="showNoSourceWarning && activeTab === 'resources'" class="message ng-binding">
				<i class="fa"></i>{{ 'MEDIACLIP_NO_MEDIAFILE_ASSOCIATED' | translate:translations }}
			</span>
			<span *ngIf="showNoSourceWarning && activeTab !== 'resources'" class="message ng-binding">
				<i class="fa"></i>{{ 'MEDIACLIP_NO_MEDIAFILE_ASSOCIATED_HREF' | translate:translations }} <a
					(click)="goToResources()">here</a>.
			</span>
		</div>
		<!-- Different tabs of mediaclip details -->
		<mediaclip-details-metadata *ngIf="entity && tabLoadedBefore('metadata')" [form]="form" [mediaclip]="entity"
			[hidden]="activeTab !== 'metadata'"></mediaclip-details-metadata>
		<mediaclip-details-chapters *ngIf="entity && tabLoadedBefore('chapters')" [form]="form" [mediaclip]="entity"
			[hidden]="activeTab !== 'chapters'"></mediaclip-details-chapters>
		<bb-fitmode *ngIf="entity && tabLoadedBefore('fitmode')" [screen]="'mediaclipDetails'" [form]="form"
			[(entity)]="entity" [hidden]="activeTab !== 'fitmode'"></bb-fitmode>
		<mediaclip-details-thumbnail *ngIf="entity && tabLoadedBefore('thumbnail')" [form]="form" [mediaclip]="entity"
			(mediaclipChange)="thumbnailChange()" [hidden]="activeTab !== 'thumbnail'"></mediaclip-details-thumbnail>
		<mediaclip-details-embed *ngIf="entity && tabLoadedBefore('embed')" [form]="form"
			[hidden]="activeTab !== 'embed'" [mediaclip]="entity" [isActive]="activeTab === 'embed'">
		</mediaclip-details-embed>
		<mediaclip-details-resources *ngIf="entity && tabLoadedBefore('resources')" [form]="form"
			[hidden]="activeTab !== 'resources'" [mediaclip]="entity" [isActive]="activeTab === 'resources'">
		</mediaclip-details-resources>
		<mediaclip-details-resources *ngIf="entity && tabLoadedBefore('streams')" [form]="form"
			[hidden]="activeTab !== 'streams'" [mediaclip]="entity" [isActive]="activeTab === 'streams'">
		</mediaclip-details-resources>
		<mediaclip-details-resources *ngIf="entity && tabLoadedBefore('source')" [form]="form"
			[hidden]="activeTab !== 'source'" [mediaclip]="entity" [isActive]="activeTab === 'source'">
		</mediaclip-details-resources>
		<mediaclip-details-live *ngIf="entity && tabLoadedBefore('bb-streams')" [form]="form"
			[hidden]="activeTab !== 'bb-streams'" [mediaclip]="entity" [liveStreamDetails]="liveStreamDetails">
		</mediaclip-details-live>
		<mediaclip-details-languages *ngIf="entity && tabLoadedBefore('languages')" [form]="form"
			[hidden]="activeTab !== 'languages'" [playerApi]="playerApi" [mediaclip]="entity"
			[isActive]="activeTab === 'languages'"></mediaclip-details-languages>
		<mediaclip-details-restreaming *ngIf="entity && tabLoadedBefore('restreaming')" [form]="form"
			[hidden]="activeTab !== 'restreaming'" [mediaclip]="entity" [isActive]="activeTab === 'restreaming'"
			[liveStreamDetails]="liveStreamDetails"></mediaclip-details-restreaming>
		<mediaclip-details-export *ngIf="entity && tabLoadedBefore('social')" [form]="form"
			[hidden]="activeTab !== 'social'" [mediaclip]="entity" [isActive]="activeTab === 'social'">
		</mediaclip-details-export>
		<mediaclip-details-react *ngIf="entity && tabLoadedBefore('react')" [form]="form"
			[hidden]="activeTab !== 'react'" [mediaclip]="entity" [isActive]="activeTab === 'react'">
		</mediaclip-details-react>
	</div>
	<div *ngIf="!['streams', 'react', 'chapters'].includes(activeTab)" class="body-column preview-container">
		<ng-container *ngIf="!isNew && entity?.id">
			<h3>{{'PREVIEW' | translate}}</h3>
			<div [ngSwitch]="entity.mediatype" class="preview-wrapper">
				<div *ngSwitchCase="'video'">
					<bb-player [forcePlayerCreation]="forcePlayerCreation" [transparentBackground]="false"
						(onPlayerCreated)="playerCreated($event)" [mediaclip]="entity" [autoplay]="false"
						[playout]="previewPlayout"
						[playoutOverrides]="{width: '100%', responsiveSizing: 'true', allowImageSequence:'false', fullScreen:'Hide'}">
					</bb-player>
				</div>

				<div *ngSwitchCase="'audio'">
					<bb-player [forcePlayerCreation]="forcePlayerCreation" [transparentBackground]="false"
						(onPlayerCreated)="playerCreated($event)" [mediaclip]="entity" [autoplay]="false"
						[playout]="previewPlayout"
						[playoutOverrides]="{responsiveSizing:'false', height:'30',showBigPlayButton:'false',showBigReplayButton:'false',qualitySelector:'hide',fullScreen:'hide',volumeOrientation:'horizontal',timeDisplay:'Show progress time',controlBar:'Show',alphaControlBar:'100'}">
					</bb-player>
				</div>

				<span *ngSwitchCase="'image'" [innerHTML]="entity | thumbnail:640:360 | async" class="thumb"></span>
			</div>
			<div class="mediaclip-actions">
				<span *ngIf="entity.mediatype==='video'" class="button" [ngClass]="{'active': preview}"
					(click)="preview = !preview"><i class="fa fa-arrows-h"></i>{{ 'PREVIEW' | translate }}</span>
			</div>
		</ng-container>
		<div class="entity-technical-details" *ngIf="entity">
			<div>
				<bb-entity-details [entity]="entity"></bb-entity-details>

				<div *ngIf="!transcodingFinished && mediaclip?.originalfilename !== '' && !isNew">
					<h3>{{ 'TRANSCODING' | translate }}</h3>
					<bb-transcoding [mediaclipId]="mediaclip?.id" (finished)="transcodingFinished = $event">
					</bb-transcoding>
				</div>

				<div *ngIf="mediaclip?.sourcetype === 'live' && isLiveClip && liveStreamIngestDetails">

					<h3>{{ 'INGEST_DETAILS' | translate }}</h3>

					<div *ngFor="let ingestDetails of liveStreamIngestDetails.data?.ingest | keyvalue">
						<h2 *ngIf="liveStreamIngestDetails.data?.ingest?.length > 1">#{{ ingestDetails.key + 1 }}</h2>
						<div class="line">
							<label>{{ 'INGEST_STATUS' | translate }}</label>
							<code class="text-only">{{ ingestDetails?.value?.state }}</code>
						</div>
						<div *ngIf="ingestDetails?.value?.details">
							<div class="line" *ngIf="ingestDetails.value.details['video-mimetype']">
								<label>{{ 'VIDEO_MIMETYPE' | translate }}</label>
								<code>{{ ingestDetails?.value?.details['video-mimetype'] }}</code>
							</div>
							<div class="line" *ngIf="ingestDetails.value.details['video-bps']">
								<label>{{ 'VIDEO_BPS' | translate }}</label>
								<code>{{ ingestDetails?.value?.details['video-bps'] }}</code>
							</div>
							<div class="line" *ngIf="ingestDetails.value.details['video-codec']">
								<label>{{ 'VIDEO_CODEC' | translate }}</label>
								<code>{{ ingestDetails?.value?.details['video-codec'] }}</code>
							</div>
							<div class="line" *ngIf="ingestDetails.value.details['video-height']">
								<label>{{ 'VIDEO_HEIGHT' | translate }}</label>
								<code
									class="text-only">{{ ingestDetails?.value?.details['video-height'] }}{{ 'PX' | translate }}</code>
							</div>
							<div class="line" *ngIf="ingestDetails.value.details['video-width']">
								<label>{{ 'VIDEO_WIDTH' | translate }}</label>
								<code>{{ ingestDetails?.value?.details['video-width'] }}{{ 'PX' | translate }}</code>
							</div>
							<div class="line" *ngIf="ingestDetails.value.details['video-fps']">
								<label>{{ 'VIDEO_FPS' | translate }}</label>
								<code>{{ ingestDetails?.value?.details['video-fps'] }}</code>
							</div>
							<div class="line" *ngIf="ingestDetails.value.details['audio-mimetype']">
								<label>{{ 'AUDIO_MIMETYPE' | translate }}</label>
								<code>{{ ingestDetails?.value?.details['audio-mimetype'] }}</code>
							</div>
							<div class="line" *ngIf="ingestDetails.value.details['audio-bps']">
								<label>{{ 'AUDIO_BPS' | translate }}</label>
								<code>{{ ingestDetails?.value?.details['audio-bps'] }}</code>
							</div>
							<div class="line" *ngIf="ingestDetails.value.details['audio-codec']">
								<label>{{ 'AUDIO_CODEC' | translate }}</label>
								<code>{{ ingestDetails?.value?.details['audio-codec'] }}</code>
							</div>
							<div class="line" *ngIf="ingestDetails.value.details['audio-freq']">
								<label>{{ 'AUDIO_FREQ' | translate }}</label>
								<code>{{ ingestDetails?.value?.details['audio-freq'] }} {{ 'HZ' | translate }}</code>
							</div>
							<div class="line" *ngIf="ingestDetails.value.details['stream-title']">
								<label>{{ 'STREAM_TITLE' | translate }}</label>
								<code>{{ ingestDetails?.value?.details['stream-title'] }}</code>
							</div>
							<div class="line" *ngIf="ingestDetails.value.details['track-title']">
								<label>{{ 'TRACK_TITLE' | translate }}</label>
								<code>{{ ingestDetails?.value?.details['track-title'] }}</code>
							</div>
						</div>
					</div>
				</div>

				<div *ngIf="mediaclip?.sourcetype === 'live' && isLiveClip && listeners !== null">

					<h3>{{ 'DELIVERY_DETAILS' | translate }}</h3>

					<div>
						<div class="line">
							<label>{{ 'LISTENERS' | translate }}</label>
							<code>{{ listeners }}</code>
						</div>
					</div>
				</div>

				<bb-checklist [items]="checklistItems"></bb-checklist>

				<h3 *ngIf="!isNew">{{ 'ANALYTICS' | translate }}</h3>
				<a *ngIf="!isNew" class="button" [ngClass]="{'disabled': !entity?.id}"
					[routerLink]="['/analytics/statistics/', entity.id]">{{ 'GO_TO_CLIP_ANALYTICS' | translate }}</a>

				<ng-container *ngIf="(entity?.mediatype === 'video' || entity?.mediatype === 'audio') && !isLiveClip">
					<div [hasPermission]="'interactivity'">
						<h3>{{ 'INTERACTIVITY' | translate }}</h3>
						<div *ngIf="!hasTimeline()"><a class="button" [routerLink]="['/library/interactivity/new']"
								[queryParams]="{ parentEntityType: 'MediaClip', parentEntityId: entity.id}">{{
								'ADD_INTERACTIVITY' | translate }}</a></div>
						<div *ngIf="hasTimeline()"><a class="button"
								[routerLink]="['/library/interactivity/' + mediaclip.timelines[0].id]">{{
								'EDIT_INTERACTIVITY' | translate }}</a></div>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
</form>

<ng-template #deleteTemplate>
	<div>
		<p>
			{{ relationInfo.defaultContents }}
		</p>
		<p class="loading-relations"
			*ngIf="relationInfo?.relations?.project?.length && !relationInfo?.projects?.length">
			{{ 'ENTITY_USED_IN_X_ENTITIES' | translate: {x: relationInfo?.relations?.project?.length, entities: (
			(relationInfo?.relations?.project?.length === 1 ? 'PROJECT' : 'PROJECTS') | translate | lowercase )} }}
		</p>
		<p *ngIf="relationInfo?.projects?.length">
			{{ 'ENTITY_USED_IN_ENTITIES' | translate: {entities: ( 'PROJECTS' | translate | lowercase )} }}
		</p>
	</div>
	<ul class="project-list" *ngIf="relationInfo?.projects?.length">
		<li class="project" *ngFor="let project of relationInfo.projects">
			<a class="blue" [routerLink]="['/library/project/' + project.id]">
				{{ project.title }}
			</a>
		</li>
	</ul>
</ng-template>

<bb-versions *ngIf="showVersions" (clickOutside)="showVersions = false" [clickOutsideExclude]="historyButton"
	(versionSelected)="loadVersion($event)" (versionStateSelected)="setVersionState($event)"
	[entityDetails]="entityDetails" [entityConfiguration]="entityConfiguration"></bb-versions>

<bb-actions-bar (onSave)="save($event)" (onCancel)="cancel()" (onDelete)="delete($event)" [form]="form"
	[entity]="entity">
	<span *ngIf="mediaclip && mediaclip.mediatype==='video' && !['react', 'resources'].includes(activeTab)"
		class="action-button" [ngClass]="{'active': preview}" (click)="preview = !preview">{{ 'PREVIEW' | translate
		}}</span>
	<div [hasPermission]="'root'" class="root action-button position-start">
		<div (click)="showVersions = !showVersions" #historyButton>
			{{ 'HISTORY' | translate }}
			<i class="fa fa-angle-up" *ngIf="showVersions"></i>
			<i class="fa fa-angle-down" *ngIf="!showVersions"></i>
		</div>
	</div>
</bb-actions-bar>
